import { useLanguage } from '../../i18n/LanguageContext';
import { getServiceDetail, siteContent } from '../../data/siteContent';
import { SectionHeading, Surface } from '../../components/SitePrimitives';

const ServicePage = ({ serviceKey }) => {
    const { language } = useLanguage();
    const content = siteContent[language];
    const detail = getServiceDetail(language, serviceKey);
    const service = content.services.find((item) => item.key === serviceKey);

    return (
        <main className="bg-nude-50">
            <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24">
                <div className="flex flex-col items-center text-center">
                    <div className="service-icon-wrap h-20 w-20">
                        <img src={service.icon} alt="" className="h-12 w-12 object-contain" />
                    </div>
                    <SectionHeading eyebrow="Neuroptimisme" title={detail.title} intro={detail.intro} />
                    {detail.lead && <p className="-mt-3 mb-9 text-base font-medium text-brown-50">{detail.lead}</p>}
                </div>
                <div className="space-y-7">
                    {detail.sections.map((section, index) => (
                        <Surface key={section.title} className={`grid items-center gap-8 p-7 sm:p-10 ${index % 2 === 1 ? 'lg:grid-cols-[1.25fr_0.75fr]' : 'lg:grid-cols-[0.75fr_1.25fr]'}`}>
                            {section.image && (
                                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''} flex items-center justify-center rounded-2xl bg-[#f9eee7] p-6`}>
                                    <img src={section.image} alt="" className="max-h-56 w-full object-contain" />
                                </div>
                            )}
                            <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                                <h2 className="text-2xl font-medium leading-tight tracking-tight text-brown-50">{section.title}</h2>
                                <p className="mt-4 whitespace-pre-line text-base leading-8 text-stone-600">{section.body}</p>
                            </div>
                        </Surface>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default ServicePage;
